import type * as React from "react"

import {
  PROPOSAL_STATUSES,
  type ProposalStatuses
} from "../../Proposals/constants/proposal-statuses-keys.ts"

const CONTRACT_STATUSES = {
  DRAFT: "draft",
  PENDING_TO_REVIEW: "pending_review",
  APPROVED: "approved",
  DECLINED: "declined",
  CANCELLED: "cancelled",
  SENT_TO_CLIENT: "sent",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  EXPIRED: "expired"
} as const

type ContractStatusesKeys = keyof typeof CONTRACT_STATUSES
type ContractStatuses = (typeof CONTRACT_STATUSES)[ContractStatusesKeys]

const CONTRACT_STATUSES_OBJ: Record<
  string,
  {
    id: ContractStatuses
    value: ContractStatuses
    label: string
    style: React.CSSProperties
  }
> = {
  [CONTRACT_STATUSES.DRAFT]: {
    id: CONTRACT_STATUSES.DRAFT,
    value: CONTRACT_STATUSES.DRAFT,
    label: "Draft",
    style: {
      color: "#616d73",
      backgroundColor: "#ECEFF1",
      borderColor: "#ECEFF1"
    }
  },
  [CONTRACT_STATUSES.PENDING_TO_REVIEW]: {
    id: CONTRACT_STATUSES.PENDING_TO_REVIEW,
    value: CONTRACT_STATUSES.PENDING_TO_REVIEW,
    label: "In Review",
    style: {
      color: "#6e21f3",
      backgroundColor: "#efe3fd",
      borderColor: "#efe3fd"
    }
  },
  [CONTRACT_STATUSES.APPROVED]: {
    id: CONTRACT_STATUSES.APPROVED,
    value: CONTRACT_STATUSES.APPROVED,
    label: "Approved",
    style: {
      color: "#4CAF50",
      backgroundColor: "#E8F5E9",
      borderColor: "#E8F5E9"
    }
  },
  [CONTRACT_STATUSES.DECLINED]: {
    id: CONTRACT_STATUSES.DECLINED,
    value: CONTRACT_STATUSES.DECLINED,
    label: "Under Revision",
    style: {
      color: "#FF9800",
      backgroundColor: "#FFF3E0",
      borderColor: "#FFF3E0"
    }
  },
  [CONTRACT_STATUSES.CANCELLED]: {
    id: CONTRACT_STATUSES.CANCELLED,
    value: CONTRACT_STATUSES.CANCELLED,
    label: "Cancelled",
    style: {
      color: "#E53935",
      backgroundColor: "#FFEBEE",
      borderColor: "#FFEBEE"
    }
  },
  [CONTRACT_STATUSES.SENT_TO_CLIENT]: {
    id: CONTRACT_STATUSES.SENT_TO_CLIENT,
    value: CONTRACT_STATUSES.SENT_TO_CLIENT,
    label: "Sent to Client",
    style: {
      color: "#0097A7",
      backgroundColor: "#E0F7FA",
      borderColor: "#E0F7FA"
    }
  },
  [CONTRACT_STATUSES.ACCEPTED]: {
    id: CONTRACT_STATUSES.ACCEPTED,
    value: CONTRACT_STATUSES.ACCEPTED,
    label: "Accepted",
    style: {
      color: "#2E7D32",
      backgroundColor: "#C8E6C9",
      borderColor: "#C8E6C9"
    }
  },
  [CONTRACT_STATUSES.REJECTED]: {
    id: CONTRACT_STATUSES.REJECTED,
    value: CONTRACT_STATUSES.REJECTED,
    label: "Rejected",
    style: {
      color: "#C62828",
      backgroundColor: "#FFCDD2",
      borderColor: "#FFCDD2"
    }
  },
  [CONTRACT_STATUSES.EXPIRED]: {
    id: CONTRACT_STATUSES.EXPIRED,
    value: CONTRACT_STATUSES.EXPIRED,
    label: "Expired",
    style: {
      color: "#757575",
      backgroundColor: "#F5F5F5",
      borderColor: "#F5F5F5"
    }
  }
}

const CONTRACT_STATUSES_MAP = Object.fromEntries(
  Object.values(CONTRACT_STATUSES_OBJ).map((item) => [item.label, item])
) as Record<
  string,
  (typeof CONTRACT_STATUSES_OBJ)[keyof typeof CONTRACT_STATUSES_OBJ]
>

const CONTRACT_SHARE_EMAIL_STATUSES = [
  PROPOSAL_STATUSES.APPROVED,
  PROPOSAL_STATUSES.SENT_TO_CLIENT
] as ProposalStatuses[]

export {
  CONTRACT_STATUSES,
  CONTRACT_SHARE_EMAIL_STATUSES,
  CONTRACT_STATUSES_OBJ,
  CONTRACT_STATUSES_MAP,
  type ContractStatuses
}
